(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.bet-events-toggle-btn.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.bet-events-toggle-btn.js');
"use strict";


const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const DrawCardBetEventsToggleBtn = _ref => {
  let {
    className,
    isToggled,
    onClick
  } = _ref;
  const blockName = 'pg_draw_card__bet_events_toggle_btn';
  const classNames = clx(blockName, 'pg_draw_card_component', className, {
    ["".concat(blockName, "--is-toggled")]: isToggled
  });
  return React.createElement("div", {
    className: classNames,
    onClick: onClick
  }, React.createElement(Button, {
    iconPosition: "center",
    size: 400,
    tabIndex: -1,
    transparent: true
  }, React.createElement(Icon, {
    icon: "menu-down"
  })));
};
setGlobal('svs.components.tipsen.drawCardComponents.DrawCardBetEventsToggleBtn', DrawCardBetEventsToggleBtn);

 })(window);